export const CreateBPBar = function ({
  createMarker,
  isDisabled = false
}: {
  createMarker: () => void;
  isDisabled?: boolean;
}) {
  const handleClick = () => {
    createMarker();
  };
  return (
    <button
      //className="absolute left-1/2 top-2 z-10 w-36 -translate-x-1/2 cursor-pointer rounded-md bg-white bg-opacity-90 p-2 shadow-md"
      className={[
        "absolute left-1/2 top-2 z-10 w-36 -translate-x-1/2 rounded-md p-2 text-xs shadow-md",
        isDisabled
          ? "cursor-not-allowed bg-gray-200 text-gray-500"
          : "cursor-pointer bg-white bg-opacity-90 text-gray-900 hover:bg-opacity-100"
      ].join(" ")}
      role="button"
      tabIndex={0}
      disabled={isDisabled}
      //onKeyDown={e => (e.key === "Enter" || e.key === " ") && handleClick()}
      onClick={handleClick}
    >
      <div className="flex items-center text-xs">+ Add Boarding Point</div>
    </button>
  );
};
